<span class="head_notification notitogg" *ngIf="!isAdmin" (click)="showNotification.emit()">
  <i class="notification-icon notitogg"></i>
  <div *ngIf="getNotificationCountObj!= undefined && getNotificationCountObj.TotalCount != 0">
    <small class="notitogg">{{getNotificationCountObj.TotalCount}}</small>
  </div>
</span>

<!-- Start Notification Popup -->
<div class="notification-container">
  <div class="notification_outer" *ngIf="NotificationList && getNotificationCountObj != undefined && generalService.NotificationAlert">
    <div class="message_title">
      <h3>Notifications</h3>
    </div>
    <div class="notification_list_out">

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.Approvals)">
        <a class="flex-row" (click)="getNotificationCountObj.Approvals > 0 ? GetApprovalCount() : null">
          <i class="approval-icon me-1"></i>Approvals ({{getNotificationCountObj.Approvals}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.FollowUp)">
        <a (click)="getNotificationCountObj.FollowUpCount > 0 ? getNotificationFollowups(this.lastAccessedFacility) : null;"
          class="flex-row">
          <i class="followUp-icon me-1"></i> Follow-Up({{getNotificationCountObj.FollowUpCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.Tasks)">
        <a class="flex-row"
          (click)="getNotificationCountObj.Tasks > 0 ? getNotificationTask(this.lastAccessedFacility) : null;"><i
            class="task-icon me-1"></i>
          Tasks ({{getNotificationCountObj.Tasks}})</a>
        <a class="btn plus_notification me-1" type="button" (click)="routToTaskCreate()" *ngIf="createRightforTask">
          <i class="plusbtn_icon"></i>
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.ScheduleMoveIn)">
        <a (click)="getNotificationCountObj.ScheduledMoveInsCount > 0 ? getNotificationSchMoveIns(this.lastAccessedFacility) : null;"
          class="flex-row"><i class="moveIn-icon me-1"></i> Schedule Move-In
          ({{getNotificationCountObj.ScheduledMoveInsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.ScheduleMoveOut)">
        <a (click)="getNotificationCountObj.ScheduledMoveoutCount > 0 ? getNotificationScheduledMoveOut(this.lastAccessedFacility) : null;"
          class="flex-row"><i class="moveOut-icon me-1"></i> Schedule Move-Out
          ({{getNotificationCountObj.ScheduledMoveoutCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.AuctionEligibleUnits)">
        <a class="flex-row"
          (click)="getNotificationCountObj.AuctionEligibleUnits > 0 ? AuctionApprovalsForFacilities() : null"><i
            class="auction-icon me-1"></i> Auction Eligible
          Units ({{getNotificationCountObj.AuctionEligibleUnits}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.UnitsToBeLocked)">
        <a (click)="getNotificationCountObj.UnitsToBeLockedCount > 0 ? getNotificationUnitsLocked(this.lastAccessedFacility) : null;"
          class="flex-row"><i class="lock-icon me-1"></i> Units to be Locked
          ({{getNotificationCountObj.UnitsToBeLockedCount}})</a>
        <a *ngIf="getNotificationCountObj.UnitsToBeLockedCount > 0" href="javascript:;" class="close"
          title="Remove All Notifications" data-bs-toggle="modal" data-bs-target="#removeAllNotificatonsModal"
          data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveAllNoticeModel(removeAllNotificatonsModal, this.lastAccessedFacility, 'UnitsToBeLocked')"><i
            class="fas fa-times"></i></a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.UnitsToBeUnLocked)">
        <a (click)="getNotificationCountObj.UnitsToBeUnLockedCount > 0 ? getNotificationUnitsUnLocked(this.lastAccessedFacility) : null"
          class="flex-row"><i class="unlock-icon me-1"></i> Units to be UnLocked
          ({{getNotificationCountObj.UnitsToBeUnLockedCount}})</a>
        <a *ngIf="getNotificationCountObj.UnitsToBeUnLockedCount > 0" href="javascript:;" class="close"
          title="Remove All Notifications" data-bs-toggle="modal" data-bs-target="#removeAllNotificatonsModal"
          data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveAllNoticeModel(removeAllNotificatonsModal, this.lastAccessedFacility, 'UnitsToBeUnLocked')"><i
            class="fas fa-times"></i></a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.AutoCreditCardDeclines)">
        <a class="flex-row"
          (click)="getNotificationCountObj.AutoCreditCardDeclineCount > 0 ? getNotificationAutoCreditCardDecline(this.lastAccessedFacility) : null">
          <i class="auto_creditcard me-1"></i> Auto Credit Card Declines
          ({{getNotificationCountObj.AutoCreditCardDeclineCount}})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.InventoryReorder)">
        <a (click)="getNotificationCountObj.InventoryReorderCount > 0 ? getNotificationInventoryReorder(this.lastAccessedFacility) : null"
          class="flex-row"><i class="inventory_reorder me-1"></i> Inventory Reorder
          ({{getNotificationCountObj.InventoryReorderCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.OnlineRentals)">
        <a (click)="getNotificationCountObj.OnlineRentalsCount > 0 ? getNotificationOnRentals(this.lastAccessedFacility) : null"
          class="flex-row"><i class="rental-icon me-1"></i> Online Rentals
          ({{getNotificationCountObj.OnlineRentalsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.OnlinePayments)">
        <a (click)="getNotificationCountObj.OnlinePaymentsCount > 0 ? getNotificationOnlinePayment(this.lastAccessedFacility) : null"
          class="flex-row"><i class="payment-icon me-1"></i> Online Payments
          ({{getNotificationCountObj.OnlinePaymentsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.OnlineReservations)">
        <a (click)="getNotificationCountObj.OnlineReservationsCount > 0 ? getNotificationOnlineReservation(this.lastAccessedFacility) : null"
          class="flex-row"><i class="reservation-icon me-1"></i> Online Reservations
          ({{getNotificationCountObj.OnlineReservationsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.OnlineInquiries)">
        <a (click)="getNotificationCountObj.OnlineInquiriesCount > 0 ? getNotificationOnlineInquiries(this.lastAccessedFacility) : null"
          class="flex-row"><i class="inquiries-icon me-1"></i> Online Inquiries
          ({{getNotificationCountObj.OnlineInquiriesCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.RentRaiseAlerts)">
        <a class="flex-row"
          (click)="getNotificationCountObj.RentRaiseBatch > 0 ? getNotificationRentRaiseAlt(this.lastAccessedFacility) : null">
          <i class="arrow-alt-circle me-1"></i>Rent Raise Alerts ({{getNotificationCountObj.RentRaiseBatch}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.CallCenterAlerts)">
        <a (click)="getNotificationCountObj.CallCenterAlertsCount > 0 ? getNotificationCallCenterAlerts(this.lastAccessedFacility) : null"
          class="flex-row"><i class="callCenter-icon me-1"></i> Call Center Alerts
          ({{getNotificationCountObj.CallCenterAlertsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.DayEndLettersInvoices)">
        <a (click)="getNotificationCountObj.DayEndLettersNInvoicesCount > 0 ? getNotificationDayEndTenantLettersAndNoticesByDate(this.lastAccessedFacility) : null"
          class="flex-row"><i class="invoice-icon me-1"></i> Day End Letters & Invoices
          ({{getNotificationCountObj.DayEndLettersNInvoicesCount}})</a>
        <span *ngIf="getNotificationCountObj.DayEndLettersNInvoicesCount > 0">
          <a href="javascript:;" class="close" title="Remove All Notifications" data-bs-toggle="modal"
            data-bs-target="#removeAllNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
            (click)="onRemoveAllNoticeModel(removeAllNotificatonsModal, this.lastAccessedFacility, 'DayEndLetterInvoice')"><i
              class="fas fa-times"></i></a>
        </span>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.DayEndReports)">
        <a (click)="getNotificationCountObj.DayEndReportsCount > 0 ? getNotificationDayEndReportsByDate(this.lastAccessedFacility) : null"
          class="flex-row"><i class="report-icon me-1"></i> Day End Reports
          ({{getNotificationCountObj.DayEndReportsCount}})</a>
        <span *ngIf="getNotificationCountObj.DayEndReportsCount > 0">
          <a href="javascript:;" class="close" title="Remove All Notifications" data-bs-toggle="modal"
            data-bs-target="#removeAllNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
            (click)="onRemoveAllNoticeModel(removeAllNotificatonsModal, this.lastAccessedFacility, 'DayEndReports')"><i
              class="fas fa-times"></i></a>
        </span>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.FileReadyToDownload)">
        <a (click)="getNotificationCountObj.FileExportsCount > 0 ? getNotificationFileExport(this.lastAccessedFacility) : null"
          class="flex-row"><i class="fas fa-download me-1"></i> File Ready to download
          ({{getNotificationCountObj.FileExportsCount}})</a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.MailhouseErrors)">
        <a (click)="getNotificationCountObj.MailHouseErrors > 0 ? getNotificationMailhouse(this.lastAccessedFacility) : null"
          class="flex-row">
          <i class="fas fa-mailhouse me-1"></i> Mailhouse Errors
          ({{getNotificationCountObj.MailHouseErrors}})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.ScheduledReports)">
        <a (click)="getNotificationCountObj.ScheduleReportsCount > 0 ? getNotificationScheduledReports(this.lastAccessedFacility) : null"
          class="flex-row">
          <i class="scheduled_report-icon"></i> Scheduled Reports
          ({{getNotificationCountObj.ScheduleReportsCount}})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.ExpiredProofOfPP)">
        <a (click)="getNotificationCountObj.ExpiredProofofPropertyProtectionCount > 0 ? getNotificationExpiredProofOfPP(this.lastAccessedFacility) : null"
          class="flex-row"><i class="proofofins_report-icon me-1"></i>Expired Proof of Property Protection
          ({{ getNotificationCountObj.ExpiredProofofPropertyProtectionCount }})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.UnitsRemovedFromAuction)">
        <a (click)="getNotificationCountObj.UnitsRemovedfromAuction > 0 ? getNotificationRemovedFromAuction(this.lastAccessedFacility) : null"
          class="flex-row"><i class="unitsremovedfromAuction_report-icon me-1"></i>Units Removed from Auction
          ({{ getNotificationCountObj.UnitsRemovedfromAuction }})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions.PendingRemotePayments)">
        <a (click)="getNotificationCountObj.PendingRemotePayPayment >= 0 ? getNotificationPendingRemotePayments(this.lastAccessedFacility) : null"
          class="flex-row"><i class="Pending_Remote_Payment-icon me-1"></i>Pending Remote Payments
          ({{ getNotificationCountObj.PendingRemotePayPayment}})
        </a>
      </div>

      <div class="notification_list" *ngIf="isNotificationAssigned(ENotificationOptions['Declined ACH/EFT Payments'])">
        <a (click)="getNotificationCountObj.DeclinedACHPayments > 0 ? getNotificationDeclinedACHPayments(this.lastAccessedFacility) : null"
          class="flex-row"><i class="declined_ACH_Payments_icon"></i>{{declinedACHPaymentsTitle}} ({{ getNotificationCountObj.DeclinedACHPayments}})
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationApprovalsSubCategory  || generalService.NotificationAlert == false) && generalService.getNotificationApprovalsSubCategoryObj != undefined && generalService.getNotificationApprovalsSubCategoryObj != null">
    <div class="message_title">
      <h3>Approvals</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationApprovalSubCategory()"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list"
        (click)="onRoutetoApprovalCount('Reversal', generalService.getNotificationApprovalsSubCategoryObj.ReversalCount)">
        <a href="javascript:;">Reversals
          <span>({{ generalService.getNotificationApprovalsSubCategoryObj.ReversalCount }})</span></a>
      </div>
      <div class="notification_det_list"
        (click)="onRoutetoApprovalCount('Refund', generalService.getNotificationApprovalsSubCategoryObj.RefundCount)">
        <a href="javascript:;">Refunds
          <span>({{ generalService.getNotificationApprovalsSubCategoryObj.RefundCount }})</span></a>
      </div>
      <div class="notification_det_list"
        (click)="onRoutetoApprovalCount('AllowanceReversalFacilityCount', generalService.getNotificationApprovalsSubCategoryObj.AllowanceReversalCount)">
        <a href="javascript:;">Allowance Reversals
          <span>({{ generalService.getNotificationApprovalsSubCategoryObj.AllowanceReversalCount }})</span></a>
      </div>
    </div>
  </div>

  <div class="notification_outer" *ngIf="showFacilitywithCount">
    <div class="message_title">
      <h3>{{FacilityCountHeader}}</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationApprovalsCount()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let storageFacility of GetFacilityApprovalCountsObj">
        <a href="javascript:;" style="width:72%" (click)="GetApprovalDetails(storageFacility.FacilityId)">
          <span>{{storageFacility.Name}} - </span>
          <span>{{storageFacility.Count}}</span>
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer" *ngIf="NotificationApprovals && getNotificationApprovalsObj">
    <div class="message_title">
      <h3>{{getNotificationApprovalsObj.CategoryType}}</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationApproval()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let details of getNotificationApprovalsObj.UnitsList">
        <a *ngIf="!details.MerchandiseSaleId; else merchSale" href="javascript:;" style="width:72%"
          (click)="routeToRefundReversalOrLedger(details, getNotificationApprovalsObj.CategoryType, true)">
          <span>{{details.CustomerName}} - </span>
          <span>{{details.UnitNo}} - </span>
          <span>${{details.Amount}}</span>
        </a>
        <ng-template #merchSale>
          <a href="javascript:;" style="width:72%" (click)="routeOrDoNothing(details)">
            <span>{{details.CustomerName}} - </span>
            <span *ngIf="details.CustomerName != 'Walk in'">{{details.UnitNo}} - </span>
            <span>${{details.Amount}}</span><br>
            <div *ngFor="let merchData of details.MerchandiseRefundDetails">
              <span>{{merchData.Quantity}} </span>
              <span>{{merchData.Name}} - </span>
              <span>${{merchData.Price}}</span>
            </div>
          </a>
        </ng-template>
        <a class="btn"> <i class="fas fa-check text-success" style="font-size: 14px;"
            (click)="verifyApprovalRecordFacility(details, EApprovalsDMRM.Approved, getNotificationApprovalsObj.CategoryType, ConfirmApprovalofDifferentFacility)"></i></a>
        <a href="javascript:;" class="close" title="Deny Approval"
          (click)="verifyApprovalRecordFacility(details, EApprovalsDMRM.Denied, getNotificationApprovalsObj.CategoryType, ConfirmApprovalofDifferentFacility)">
          <i class="fas fa-times"></i>
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer" *ngIf="(NotificationFollowDetail  || generalService.NotificationAlert == false) && generalService.getNotificationFollowupsObj != undefined">
    <div class="message_title">
      <h3>Follow-Up</h3>
      <a (click)="HideNotificationFollowDetail()" class="fas fa-angle-left back_list"></a>
    </div>

    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('followup')">
      <div class="notification_det_list" *ngFor="let item of generalService.getNotificationFollowupsObj">
        <a href="javascript:;" (click)="FollowUpsRoute(item)">{{item.Name}} -
          <span>{{item.Type}}</span></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationTaskDetail || generalService.NotificationAlert==false) && generalService.getNotificationTasksObj != undefined && generalService.getNotificationTasksObj != null">
    <div class="message_title">
      <h3>Tasks</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationTaskDetail()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle">
      <div class="notification_det_list" *ngFor="let item of generalService.getNotificationTasksObj">
        <a href="javascript:;" style="width:72%" (click)="routToTaskDetail(item, 1)">
          <span>{{item.Subject}} - {{commonMethodService.getAPIDateTimeToLocalDatePart(item.TaskDate) | date
            :'MM/dd/yyyy'}}</span>
          <span *ngIf="item.UnitNo != null"> - {{item.UnitNo}}</span>
        </a>
        <a class="btn" (click)="onRemoveNoticeModel(item,'Task',true)"><i class="fas fa-check text-success"
            style="font-size: 14px;" data-bs-toggle="modal" data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static"
            data-bs-keyboard="false"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationMoveInDetail || generalService.NotificationAlert==false) && generalService.getNotificationSchMoveInsObj != undefined && generalService.getNotificationSchMoveInsObj != null">
    <div class="message_title">
      <h3>Scheduled Move-In</h3>
      <a (click)="HideNotificationMoveInDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('schedulemovein')">
      <div class="notification_det_list" *ngFor="let inItem of generalService.getNotificationSchMoveInsObj">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(inItem, 'Move')">{{inItem.Name}} -
          <span>{{inItem.UnitNo}}
            ({{commonMethodService.getTimeZoneOffSetDate(inItem.MoveInDate) | date :'MM/dd/yyyy'}})</span></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationMoveOutDetail  || generalService.NotificationAlert == false) && generalService.getNotificationSchMoveOutsObj != undefined && generalService.getNotificationSchMoveOutsObj != null">
    <div class="message_title">
      <h3>Scheduled Move-Out</h3>
      <a (click)="HideNotificationMoveOutDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('schedulemoveout')">
      <div class="notification_det_list" *ngFor="let outItem of generalService.getNotificationSchMoveOutsObj">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(outItem, 'Move')">{{outItem.Name}} -
          <span>{{outItem.UnitNo}}
            ({{commonMethodService.getTimeZoneOffSetDate(outItem.MoveOutDate) | date :'MM/dd/yyyy'}})</span></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="NotificationAuctionEligibleSubCategory && getNotificationAuctionEligibleSubCategoryObj != undefined && getNotificationAuctionEligibleSubCategoryObj != null">
    <div class="message_title">
      <h3>Auction Eligible Units</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationAuctionEligibleSubCategory()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngIf="getNotificationAuctionEligibleSubCategoryObj.SubCategory.Military != 0"
        (click)="GetAuctionEligibleUnits(EAuctionSubCategoryType.Military, getNotificationAuctionEligibleSubCategoryObj.FacilityId)">
        <a href="javascript:;" style="width:72%">
          <span>Military - </span>
          <span>({{getNotificationAuctionEligibleSubCategoryObj.SubCategory.Military}})</span>
        </a>
      </div>
      <div class="notification_det_list"
        *ngIf="getNotificationAuctionEligibleSubCategoryObj.SubCategory.Bankruptcy != 0"
        (click)="GetAuctionEligibleUnits(EAuctionSubCategoryType.Bankruptcy, getNotificationAuctionEligibleSubCategoryObj.FacilityId)">
        <a href="javascript:;" style="width:72%">
          <span>Bankruptcy - </span>
          <span>({{getNotificationAuctionEligibleSubCategoryObj.SubCategory.Bankruptcy}})</span>
        </a>
      </div>
      <div class="notification_det_list"
        *ngIf="getNotificationAuctionEligibleSubCategoryObj.SubCategory.OppositionToLien != 0"
        (click)="GetAuctionEligibleUnits(EAuctionSubCategoryType.OppositionToLien, getNotificationAuctionEligibleSubCategoryObj.FacilityId)">
        <a href="javascript:;" style="width:72%">
          <span>Opposition To Lien - </span>
          <span>({{getNotificationAuctionEligibleSubCategoryObj.SubCategory.OppositionToLien}})</span>
        </a>
      </div>
      <div class="notification_det_list"
        *ngIf="getNotificationAuctionEligibleSubCategoryObj.SubCategory.AllOtherUnits != 0"
        (click)="GetAuctionEligibleUnits(EAuctionSubCategoryType.AllOtherUnits, getNotificationAuctionEligibleSubCategoryObj.FacilityId)">
        <a href="javascript:;" style="width:72%">
          <span>All Other Units - </span>
          <span>({{getNotificationAuctionEligibleSubCategoryObj.SubCategory.AllOtherUnits}})</span>
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer" *ngIf="(auctionapprovalforfac || generalService.NotificationAlert == false) && generalService.getFacilityAuctionEligibleUnitsCount != null && generalService.getFacilityAuctionEligibleUnitsCount !=undefined">
    <div class="message_title">
      <h3>Auction Approvals for Facilities</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationAuctionApprovalfac()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let storageFacility of  generalService.getFacilityAuctionEligibleUnitsCount">
        <a href="javascript:;" style="width:72%"
          (click)="GetAuctionEligibleSubCategoryCount(storageFacility.FacilityId)">
          <span>{{storageFacility.Name}} </span>
          <span>({{storageFacility.Count}}) </span>
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="NotificationAuctionEligibleUnits && getNotificationAuctionEligibleUnitsObj != undefined && getNotificationAuctionEligibleUnitsObj != null">
    <div class="message_title">
      <h3>{{getNotificationAuctionEligibleUnitsObj.CategoryType}}</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationAuctionEligibleUnits()"></a>
    </div>
    <div class="loader_noti">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let auctionUnits of getNotificationAuctionEligibleUnitsObj.UnitsList">
        <a href="javascript:;" style="width:72%">
          <span>{{auctionUnits.CustomerName}} - </span>
          <span>{{auctionUnits.UnitNo}} - </span>
          <span>${{auctionUnits.Amount}}</span>
        </a>
        <a class="btn"
          (click)="verifyApprovalAuctionEligibleUnits(auctionUnits, EAuctionEligibleUnitsApprovalStatus.Approved, ConfirmApprovalofDifferentFacility)">
          <i class="fas fa-check text-success" style="font-size: 14px;"></i></a>
        <a href="javascript:;" class="close" title="Deny Auction"
          (click)="verifyApprovalAuctionEligibleUnits(auctionUnits, EAuctionEligibleUnitsApprovalStatus.Denied, ConfirmApprovalofDifferentFacility)">
          <i class="fas fa-times"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- ============================================================================================= -->
  <div class="notification_outer"
    *ngIf="(NotificationUnitLockDetail || generalService.NotificationAlert== false) && generalService.getNotificationUnitsLockedsObj != undefined && generalService.getNotificationUnitsLockedsObj != null">
    <div class="message_title">
      <h3>Units to be Locked</h3>
      <a (click)="HideNotificationUnitLockDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Unitlock')">
      <div class="notification_det_list" *ngFor="let lock of generalService.getNotificationUnitsLockedsObj">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(lock, 'Units')">{{lock.Name}}
          - <span>{{lock.UnitNo}}</span><span *ngIf="lock.TransactionDate">
            ({{commonMethodService.getTimeZoneOffSetDate(lock.TransactionDate) | date :'MM/dd/yyyy'}})</span></a>
        <div *ngIf="!isLicenseAndDavinciExist || lock.ExemptFromOverLock">
          <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
            data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
            (click)="onRemoveNoticeModel(lock, 'UnitsToBeLocked',true)"><i class="fas fa-times"></i></a>
        </div>
        <div *ngIf="isLicenseAndDavinciExist && !lock.ExemptFromOverLock">
          <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
            data-bs-target="#syncModal" data-bs-backdrop="static" data-bs-keyboard="false" (click)="OpenSyncModal(lock)"><i
              class="fas fa-times"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="NotificationUnitUnLockDetail && generalService.getNotificationUnitsUnLockedsObj != undefined && generalService.getNotificationUnitsUnLockedsObj != null">
    <div class="message_title">
      <h3>Units to be UnLocked </h3>
      <a (click)="HideNotificationUnitUnLockDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Unitunlock')">
      <div class="notification_det_list" *ngFor="let unLock of generalService.getNotificationUnitsUnLockedsObj;">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(unLock, 'Units')">{{unLock.Name}} -
          <span>{{unLock.UnitNo}}
            ({{unLock.FormattedTDate}})</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(unLock, 'UnitsToBeUnLocked',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationAutoCreditCardDeclineDetail || generalService.NotificationAlert==false) && generalService.getNotificationAutoCreditCardDeclineObj != undefined">
    <div class="message_title">
      <h3>Auto Credit Card Declines</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationAutoCreditCardDeclineDetail()"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle">
      <div class="notification_det_list dayend_list"
        *ngFor="let autoCCDecline of generalService.getNotificationAutoCreditCardDeclineObj;">
        <a class="dayend_link" href="javascript:;" (click)="getNotificationAutoCCDeclineCountDetail(autoCCDecline)">
          <span>{{commonMethodService.getAPIDateTimeToLocalDatePart(autoCCDecline.TransDate) | date
            :'MM/dd/yyyy'}}</span>
          <span> - ({{autoCCDecline.Count}})</span>
        </a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="printNotificationAutoCreditCardDecline(autoCCDecline)"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(autoCCDecline, 'AutoCreditCardDecline',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="NotificationAutoCCDeclineDetail && getNotificationAutoCCDeclineDetailsObj != undefined">
    <div class="message_title">
      <h3>Auto Credit Card Declines</h3>
      <a class="fas fa-angle-left back_list" (click)="HideNotificationAutoCCDeclineDetail()"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle">
      <div class="notification_det_list dayend_list"
        *ngFor="let autoCCDecline of getNotificationAutoCCDeclineDetailsObj;">
        <a class="dayend_link" href="javascript:;" (click)="gotoCustomerRentalTab(autoCCDecline)">
          <span>{{autoCCDecline.CustomerName}} - {{autoCCDecline.UnitNo}} - ${{autoCCDecline.Amount}}</span>
        </a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(autoCCDecline, 'AutoCreditCardDecline',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationInventoryReorderDetail || generalService.NotificationAlert== false) && generalService.getNotificationInventoryReorderObj != undefined && generalService.getNotificationInventoryReorderObj != null">
    <div class="message_title">
      <h3>Inventory Reorder </h3>
      <a (click)="HideNotificationInventoryReorderDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle">
      <div class="notification_det_list" *ngFor="let reorder of generalService.getNotificationInventoryReorderObj;">
        <a href="javascript:;" (click)="redirectMerchandiseInventory()">{{reorder.MerchandiseName}} – Qty :
          {{reorder.Quantity}}, Reorder Lvl – {{reorder.ReorderLevel}}, Reorder Qty – {{reorder.ReorderQuantity}}
        </a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="(NotificationRentalsDetail || generalService.NotificationAlert== false) && generalService.getNotificationOnRentalsObj != undefined && generalService.getNotificationOnRentalsObj != null">
    <div class="message_title">
      <h3>Online Rentals </h3>
      <a (click)="HideNotificationRentalsDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Onlinerental')">
      <div class="notification_det_list" *ngFor="let rent of generalService.getNotificationOnRentalsObj;">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(rent, 'Rental')">{{rent.Name}}
          - <span>{{rent.UnitNo}}
            ({{commonMethodService.getTimeZoneOffSetDate(rent.TransactionDate) | date :'MM/dd/yyyy'}})</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(rent, 'OnlineRentals',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <!-- ============================================================================================= -->
  <div class="notification_outer"
    *ngIf="(NotificationPaymentDetail || generalService.NotificationAlert==false) && generalService.getNotificationOnPaymentsObj != undefined && generalService.getNotificationOnPaymentsObj != null">
    <div class="message_title">
      <h3>Online Payments</h3>
      <a (click)="HideNotificationPaymentDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Onlinepayments')">
      <div class="notification_det_list" *ngFor="let payment of generalService.getNotificationOnPaymentsObj;">
        <a href="javascript:;" (click)="redirectCustomerRentaltab(payment, 'Payment')">{{payment.Name}} -
          <span>{{payment.UnitNo}} (${{payment.PaymentAmount}})</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(payment, 'OnlinePayments',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="(NotificationReservationsDetail ||generalService.NotificationAlert==false) && generalService.getNotificationOnReservationsObj != undefined && generalService.getNotificationOnReservationsObj != null">
    <div class="message_title">
      <h3>Online Reservations</h3>
      <a (click)="HideNotificationReservationsDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Onlinereservation')">
      <div class="notification_det_list" *ngFor="let reser of generalService.getNotificationOnReservationsObj;">
        <a href="javascript:;" (click)="reservationDetailsById(reser,'Prospects')">{{reser.Name}} -
          <span>{{reser.UnitNo}}
            ({{commonMethodService.getTimeZoneOffSetDate(reser.TransactionDate) | date :'MM/dd/yyyy'}})</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(reser, 'OnlineReservations',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="(NotificationInquiriesDetail || generalService.NotificationAlert== false) && generalService.getNotificationOnInquiriesObj != undefined && generalService.getNotificationOnInquiriesObj != null">
    <div class="message_title">
      <h3>Online Inquiries</h3>
      <a (click)="HideNotificationInquiriesDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Onlineinquiry')">
      <div class="notification_det_list" *ngFor="let inQuire of generalService.getNotificationOnInquiriesObj">
        <a href="javascript:;" (click)="inquiryById(inQuire , 'Prospects')">{{inQuire.Name}} -
          <span>{{inQuire.UnitNo}}
            ({{commonMethodService.getTimeZoneOffSetDate(inQuire.TransactionDate) | date :'MM/dd/yyyy'}})</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(inQuire, 'OnlineInquiries',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="(NotificationCallCenterDetail  || generalService.NotificationAlert== false) && generalService.getNotificationCallCenterAlertsObj != undefined && generalService.getNotificationCallCenterAlertsObj != null">
    <div class="message_title">
      <h3>Call Center Alerts</h3>
      <a (click)="HideNotificationCallCenterDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('callcentrealert')">
      <div class="notification_det_list" *ngFor="let callCen of generalService.getNotificationCallCenterAlertsObj">
        <a href="javascript:;" (click)="callCenterRedirect(callCen)">{{callCen.Name}} -
          <span>{{callCen.UnitNo}} -
            {{callCen.Notes.split(' ').slice(0,2).join(' ')}}...</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(callCen, 'CallCenterAlerts',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="(NotificationRentRaiseAltDetail || generalService.NotificationAlert== false) && generalService.notificationRentRaiseAlert !=undefined && generalService.notificationRentRaiseAlert != null">
    <div class="message_title">
      <h3>Rent Raise Alerts</h3>
      <a (click)="HideNotificationRentRaiseAlt()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let rentRaise of generalService.notificationRentRaiseAlert">
        <a href="javascript:;">
          <span>{{commonMethodService.getTimeZoneOffSetDate(rentRaise.TransDate) | date :'MM/dd/yyyy - hh:mm a'}}</span>
          - <span>{{rentRaise.Count}} Customers</span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(rentRaise, 'RentRaiseAlerts',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer"
    *ngIf="(NotificationLettersInvoicesDetail || generalService.NotificationAlert==false) && generalService.getNotificationLettersAndNoticesObjByDate != undefined && generalService.getNotificationLettersAndNoticesObjByDate != null">
    <div class="message_title">
      <h3>Day End Letters & Invoices</h3>
      <a (click)="HideNotificationLettersInvoicesDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Invoices')">
      <div class="notification_det_list dayend_list"
        *ngFor="let letterByDate of generalService.getNotificationLettersAndNoticesObjByDate;">
        <a title="{{letterByDate.Tag}}" class="dayend_link" href="javascript:;"
          (click)=getNotificationDayEndTenantLettersAndNotices(letterByDate);>{{letterByDate.Tag}} -
          <span>({{commonMethodService.getTimeZoneOffSetDate(letterByDate.TDate) | date :'MM/dd/yyyy'}})</span><span> -
            ({{letterByDate.Cnt}})</span></a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdfList(letterByDate, 'DayEndLetterInvoice', 'GroupByDate')"><i
              class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemAllNoticeModel(letterByDate, 'DayEndLetterInvoice', 'GroupByDate',true)"><i
            class="fas fa-times"></i></a>
      </div>

    </div>
  </div>
  <!-- -------------------------------------------------- Letterandnotice By Date -->

  <div class="notification_outer"
    *ngIf="NotificationLettersInvoicesDetailByName && LettersAndNoticeheader == 'Letters'">
    <div class="message_title">
      <h3>Day End Letters & Invoice</h3>
      <a (click)="HideNotificationLettersInvoicesDetailByName()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('LettersGrouped')">
      <div class="notification_det_list dayend_list" *ngFor="let letterByName of letterGroupBYNameWise;">
        <a title="{{letterByName.Name}}" class="dayend_link" href="javascript:;"
          (click)=onClickGroupByName(letterByName)>{{letterByName.Notes}} - ({{letterByName.Length}}) </a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdfGroupedNameList(letterByName)"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemAllNoticeModel(letterByName, 'DayEndLetterInvoice', 'GroupByName',true)"><i
            class="fas fa-times"></i></a>
      </div>

    </div>
  </div>

  <!-----------------------Above section Group By Notes Name----------------->


  <div class="notification_outer"
    *ngIf="NotificationLettersInvoicesDetailByNameDisplay && letterGroupByNameListGrouped != undefined && LettersAndNoticeheader == 'Letters'">
    <div class="message_title">
      <h3>Letters</h3>
      <a (click)="HideNotificationLettersInvoicesDetailLetters()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('LettersAndNoticesNotes')">
      <div class="notification_det_list dayend_list" *ngFor="let letterNotes of letterGroupByNameListGrouped;">
        <a title="{{letterNotes.Name}}" class="dayend_link" href="javascript:;">{{letterNotes.Name}} </a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdf(letterNotes, 'DayEndLetterInvoice')"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(letterNotes, 'DayEndLetterInvoice',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <!-------------------------Above Scetion DIsplay letter------------------------------->
  <div class="notification_outer"
    *ngIf="NotificationLettersInvoicesDetailByDate && getNotificationLettersAndNoticesObj != undefined && LettersAndNoticeheader != 'Letters'">
    <div class="message_title">
      <h3>{{LettersAndNoticeheader}}</h3>
      <a (click)="HideNotificationLettersInvoicesDetailByDate()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('LettersAndNotices')">
      <div class="notification_det_list dayend_list" *ngFor="let letter of getNotificationLettersAndNoticesObj;">
        <a title="{{letter.Name}} - {{letter.UnitNo}} - ({{letter.Notes}})" class="dayend_link"
          href="javascript:;">{{letter.Name}} - <span>{{letter.UnitNo}} - ({{letter.Notes}})</span></a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdf(letter, 'DayEndLetterInvoice')"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(letter, 'DayEndLetterInvoice',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <!-- -------------------------------------------By Date------------------------------ -->
  <div class="notification_outer"
    *ngIf="(NotificationReportsDetailByDate|| generalService.NotificationAlert==false) && generalService.getNotificationDayEndReportsObjByDate != undefined && generalService.getNotificationDayEndReportsObjByDate != null">
    <div class="message_title">
      <h3>DayEnd Reports </h3>
      <a (click)="HideNotificationReportsDetailByDate()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('DayendreportsbyDate')">
      <div class="notification_det_list dayend_list"
        *ngFor="let dayEndByDate of generalService.getNotificationDayEndReportsObjByDate;">
        <a title="{{dayEndByDate.Tag}}" class="dayend_link" href="javascript:;"
          (click)=getNotificationDayEndReports(dayEndByDate)>{{dayEndByDate.Tag}} -
          <span>({{commonMethodService.getTimeZoneOffSetDate(dayEndByDate.TDate) | date :'MM/dd/yyyy'}})</span><span> -
            ({{dayEndByDate.Cnt}})</span></a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdfList(dayEndByDate, 'DayEndReports', 'GroupByDate')"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemAllNoticeModel(dayEndByDate, 'DayEndReports', 'GroupByDate',true)"><i
            class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <!-- ------------------------------------------Schedule Reports by FacilityId ------------------------------ -->
  <div class="notification_outer"
    *ngIf="(NotificationScheduleReportsByDate || generalService.NotificationAlert==false) && generalService.getNotificationScheduleReportsData != undefined && generalService.getNotificationScheduleReportsData != null">
    <div class="message_title">
      <h3>Scheduled Reports </h3>
      <a (click)="HideNotificationScheduleReportsByDate()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('ScheduledReports')">
      <div class="notification_det_list dayend_list"
        *ngFor="let scheduleReportByDate of generalService.getNotificationScheduleReportsData">
        <a title="{{scheduleReportByDate.ScheduledName}}" class="dayend_link" href="javascript:;"
          (click)=getNotificationScheduledReportsDetail(scheduleReportByDate)>{{scheduleReportByDate.ScheduledName}} -
          <span>({{commonMethodService.getFormattedDate(scheduleReportByDate.Date)}})</span>
          <span> -
            ({{scheduleReportByDate.ReportCount}})</span></a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print Notifications"
            (click)="generateAsPdfList(scheduleReportByDate, 'ScheduledReports', 'GroupByDate')"><i
              class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemAllNoticeModel(scheduleReportByDate, 'ScheduledReports', 'GroupByDate',true)"><i
            class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <!-- -------------------------------------------------------------------------------- -->
  <div class="notification_outer"
    *ngIf="NotificationReportsDetail && getNotificationDayEndReportsObj != undefined && getNotificationDayEndReportsObj != null">
    <div class="message_title">
      <h3>Day End Reports</h3>
      <a (click)="HideNotificationReportsDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('Dayendreports')">
      <div class="notification_det_list dayend_list" *ngFor="let dayEnd of getNotificationDayEndReportsObj">
        <a class="dayend_link" href="javascript:;">{{dayEnd.Name}}</a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print  Notifications"
            (click)="generateAsPdf(dayEnd, 'DayEndReports')"><i class="fas fa-print"></i></a>
        </span>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(dayEnd, 'DayEndReports',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>
  <div class="notification_outer" *ngIf="(NotificationFileExportsDetail|| generalService.NotificationAlert==false) && generalService.getNotificationFileExportObj != undefined &&generalService.getNotificationFileExportObj != null ">

    <div class="message_title">
      <h3>File Ready to download</h3>
      <a (click)="HideNotificationFileExportsDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="file_export_det_out" infinite-scroll [scrollWindow]="false" [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown('Fileexports')">
      <div class="file_export_det_list" *ngFor="let export of generalService.getNotificationFileExportObj">
        <a href="javascript:;" class="text-success" (click)="downloadFile(export)">{{export.Name}}<br>
          <small class="text-default">Click here to Download </small>
        </a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsFileExportModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveFileExportModel(removeNotificatonsFileExportModal, export, 'FileExports')"><i
            class="fas fa-times"></i></a>
      </div>

    </div>
  </div>

  <div class="notification_outer" *ngIf="(NotificationMailhouseErrorDateList|| generalService.NotificationAlert==false) && generalService.notificationMailhouseErrors!= null ">
    <div class="message_title">
      <h3>Mailhouse Errors</h3>
      <a (click)="HideNotificationMailhouseDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out">
      <div class="notification_det_list" *ngFor="let mailhouse of generalService.notificationMailhouseErrors">
        <a href="javascript:;" (click)="getNotificationMailhouseDateDetail(mailhouse.TDate)">
          <span>{{mailhouse.TDate}}</span> - <span>{{mailhouse.MailHouseErrorCount}}</span>
        </a>
        <a href="javascript:;" class="close" title="Remove This Notification"
          (click)="onRemAllNoticeModel(mailhouse, 'MailhouseErrors', '',true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer" *ngIf="NotificationMailhouseDateDetail  && mailhouseErrorDetails">
    <div class="message_title">
      <h3>{{selectedDate}}</h3>
      <a (click)="HideNotificationMailhouseDetailByDate()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('MailhouseErrors')">
      <div class="notification_det_list" *ngFor="let mhDetails of mailhouseErrorDetails">
        <a title="{{mhDetails.MailHouseErrorResponse}}" class="dayend_link" href="javascript:;"
          (click)="redirectCustomerCustomerInfo(mhDetails)">
          {{mhDetails.UnitNo}} - <span>{{mhDetails.LetterName}}</span> -
          <span>{{mhDetails.MailHouseErrorResponse}}</span>
        </a>
        <a href="javascript:;" class="close" title="Remove This Notification"
          (click)="onRemoveNoticeModel(mhDetails, 'MailhouseErrors',true)">
          <i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
    *ngIf="NotificationExpiredProofOfPPList && getNotificationExpiredProofOfPPsData != undefined && getNotificationExpiredProofOfPPsData != null">
    <div class="message_title">
      <h3>Expired Proof of Property Protection</h3>
      <a (click)="HideNotificationExpiredProofofPP()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('ExpiredProofOfPP')">
      <div class="notification_det_list" *ngFor="let ExpiredProofOfPP of getNotificationExpiredProofOfPPsData">
        <a href="javascript:;"
          (click)="redirectCustomerRentaltab(ExpiredProofOfPP, 'ExpiredPP')">{{ExpiredProofOfPP.TenantName}} -
          <span>{{ExpiredProofOfPP.UnitNo}} -
            {{commonMethodService.getTimeZoneOffSetDate(ExpiredProofOfPP.StopDate) | date :'MM/dd/yyyy'}}</span></a>
      </div>
    </div>
  </div>

  <div class="notification_outer"
   *ngIf="(NotificationRemovedfromPendingRemotePaymentsList || generalService.NotificationAlert == false) && generalService.getNotificationRemovedFromPendingRemotePaymentscount !=undefined && generalService.getNotificationRemovedFromPendingRemotePaymentscount != null">
   <div class="message_title">
     <h3>Pending Remote Payment</h3>
     <a (click)="HideNotificationPendingRemotePayments()" class="fas fa-angle-left back_list"></a>
   </div>
   <div class="loader_noti" *ngIf="loader_noti | async">
     <div class="lds-roller">
       <div></div>
       <div></div>
       <div></div>
       <div></div>
       <div></div>
       <div></div>
       <div></div>
       <div></div>
     </div>
   </div>
   <div class="notification_detail_out">
     <div class="notification_det_list" *ngFor="let pendingAmount  of generalService.getNotificationRemovedFromPendingRemotePaymentscount">
      <div>
         <span>{{pendingAmount.TenantName}} - {{pendingAmount.UnitNo}}</span>
         <span> (${{pendingAmount.Amount}})</span>
         <div  *ngIf="pendingAmount.SaveFailed" >
        <span class="required" style="position: relative !important;"> ({{UnSavedValue}}) </span></div>
       </div>
     </div>
   </div>
 </div>

  <div class="notification_outer"
    *ngIf="(NotificationRemovedFromAuctionList || generalService.NotificationAlert == false) && generalService.getNotificationRemovedFromAuctionData != undefined && generalService.getNotificationRemovedFromAuctionData != null">
    <div class="message_title">
      <h3>Units Removed from Auction</h3>
      <a (click)="HideNotificationRemovedFromAuction()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
      (scrolled)="onScrollDown('RemovedFromAuction')">
      <div class="notification_det_list" *ngFor="let RemovedFromAuction of generalService.getNotificationRemovedFromAuctionData">
        <a href="javascript:;"
          (click)="redirectCustomerRentaltab(RemovedFromAuction, 'Rental')">{{RemovedFromAuction.TenantName}} -
          <span>{{RemovedFromAuction.UnitNo}}</span><br>
          <span>Paid {{RemovedFromAuction.AmountPaid | currency}} - Due {{RemovedFromAuction.CurrentDue | currency}} -
            {{RemovedFromAuction.LeaseStatus}}
            <span
              *ngIf="RemovedFromAuction.RepealedDate">({{commonMethodService.getTimeZoneOffSetDate(RemovedFromAuction.RepealedDate)
              | date :'MM/dd/yyyy'}})</span></span></a>
        <a href="javascript:;" class="close" title="Remove This Notification" data-bs-toggle="modal"
          data-bs-target="#removeNotificatonsModal" data-bs-backdrop="static" data-bs-keyboard="false"
          (click)="onRemoveNoticeModel(RemovedFromAuction, 'RemovedFromAuction', true)"><i class="fas fa-times"></i></a>
      </div>
    </div>
  </div>


  <!-- Scheduled Reports - Reports List -->
  <div class="notification_outer"
    *ngIf="NotificationScheduleReportsDetail && getNotificationScheduledReportsObj != undefined && getNotificationScheduledReportsObj != null">
    <div class="message_title">
      <h3>Scheduled Reports</h3>
      <a (click)="HideNotificationScheduleReportsDetail()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" infinite-scroll [scrollWindow]="false"
      [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle">
      <div class="notification_det_list dayend_list" *ngFor="let reportData of getNotificationScheduledReportsObj;">
        <a class="dayend_link" href="javascript:;">{{reportData.ReportNames}}</a>
        <span class="dayend_print">
          <a href="javascript:;" class="print-all" title="Print  Notifications"
            (click)="generateAsPdf(reportData, 'ScheduledReports')"><i class="fas fa-print"></i></a>
        </span>
      </div>
    </div>
  </div>

  <!-- Scheduled Reports - Reports List -->
  <div class="notification_outer"
    *ngIf="(notificationDeclinedACHPayments || generalService.NotificationAlert == false) && this.generalService.getNotificationDeclinedACHPaymentsObj != undefined && this.generalService.getNotificationDeclinedACHPaymentsObj != null">
    <div class="message_title">
      <h3>{{declinedACHPaymentsTitle}}</h3>
      <a (click)="hideNotificationDeclinedACHPayments()" class="fas fa-angle-left back_list"></a>
    </div>
    <div class="loader_noti" *ngIf="loader_noti | async">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notification_detail_out" >
      <div class="notification_det_list" *ngFor="let declinedACHPayments of this.generalService.getNotificationDeclinedACHPaymentsObj">
        <a href="javascript:;"
          (click)="declinedACHPaymentsRouteToLedger(declinedACHPayments)">{{declinedACHPayments.TenantName}} -
          <span>{{declinedACHPayments.UnitNo}}</span><span>&nbsp;</span><span>({{declinedACHPayments.Amount | currency}} - {{declinedACHPayments.TransactionDate | date :'MM/dd/yyyy'}})</span></a>
      </div>
    </div>
  </div>


</div>
<!-- End Notification Popup // -->

<!-- Remove Notification popup -->
<ng-template #removeNotificatonsModal>
  <div class="modal-content">
    <div class="modal-body text-center">
      <p *ngIf="!NotificationAutoCreditCardDeclineDetail && !NotificationTaskDetail">Remove this Notification?</p>
      <p *ngIf="NotificationAutoCreditCardDeclineDetail && !NotificationTaskDetail">Remove Auto Credit Card Declines
        Notification for
        {{commonMethodService.getAPIDateTimeToLocalDatePart(this.RemoveNoticeobj.tDate) | date :'MM/dd/yyyy'}}?</p>
      <p *ngIf="NotificationTaskDetail">Flag Task as completed?</p>
      <div class="d-flex mt-3 justify-content-center">
        <button type="button" class="btn btn-outline-primary w-35 me-3"
          (click)="modalRefRemoveNotice.hide()">No</button>
        <button type="button" class="btn btn-primary w-35" (click)="removeNotification()">Yes</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #removeNotificatonsFileExportModal>
  <div class="modal-content">
    <div class="modal-body text-center">
      <p>Remove this Notification?</p>
      <div class="d-flex mt-3 justify-content-center">
        <button type="button" class="btn btn-outline-primary w-35 me-3"
          (click)="modalRefRemoveNotice.hide()">No</button>
        <button type="button" class="btn btn-primary w-35" (click)="removeFileExportNotification()">Yes</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Remove All Notifications popup -->

<ng-template #removeAllNotificatonsModal>
  <div class="modal-content">
    <div class="modal-body text-center">
      <p>Remove all Notifications?</p>
      <div class="d-flex mt-3 justify-content-center">
        <button type="button" class="btn btn-outline-primary w-35 me-3" data-bs-dismiss="modal"
          (click)="modalRefRemoveAllNotice.hide()">No</button>
        <button type="button" class="btn btn-primary w-35" (click)="removeNotification()">Yes</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ConfirmApprovalofDifferentFacility>
  <div *ngIf="approvalConfirmRecordDetails">
    <div class="modal-header">
      <h5 class="modal-title">Confirm</h5>
      <button type="button" class="close pull-right" aria-label="Close"
        (click)="approvalConfirmRecordDetails = null;modalRefApprovalDifferentFacility.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body ptb24">
      <div class="row mx-0">{{approvalConfirmRecordDetails?.confirmPopUpMessage}}</div>
    </div>
    <div class="modal-footer">
      <button *ngIf="approvalConfirmRecordDetails?.confirmPopUp == 1" class="btn btn-outline-primary me-3" type="button"
        (click)="approvalConfirmRecordDetails = null;modalRefApprovalDifferentFacility.hide()">No</button>
      <button *ngIf="approvalConfirmRecordDetails?.confirmPopUp == 1" class="btn btn-primary" type="button"
        (click)="approvaApprovalAuction()">Yes</button>
      <button *ngIf="approvalConfirmRecordDetails?.confirmPopUp == 2" type="button" class="btn btn-primary"
        data-bs-dismiss="modal" (click)="modalRefApprovalDifferentFacility.hide()">OK</button>
    </div>
  </div>
</ng-template>

<div bsModal #printReceiptPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-fullSize  modal-lg modal-xxl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Preview</h5>
        <button type="button" class="close" (click)="printFile.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <div class="row mx-0 align-items-center justify-content-center" id="recieptContainer"
            style="min-height: 500px">
            <iframe style="width:100%; height:500px;"></iframe>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<app-facility-locks [lockDetailsList]="lockDetailsList" [facilityId]="lastAccessedFacility"
[unitNo]="Currentunitno" [isNotification]="isNotification" (reLoad)="removeNotification()"></app-facility-locks>
